import DictionaryAPI from "@/web-framework/api/dictionary.js";
const state = {
    codes: {},
};

const mutations = {
    SET_CODES: (state, codes) => {
        state.codes = codes;
    }
};

const actions = {
    // 获取站点信息
    loadCodes({ commit }) {
        return new Promise((resolve, reject) => {
            DictionaryAPI.codeTree().then(result => {
                if (result.success) {
                    commit("SET_CODES", result.data || {});
                }
                resolve();
            }).catch(error => {
                reject(error);
            });
        });
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};